import { createContext, useState } from "react";

const ExchangeTypeContext = createContext({
  exchangeType: undefined,
  setExchangeType: (exchangeType: any) => {},
});

const ExchangeTypeContextProvider = ({ children }) => {
  const [exchangeType, setExchangeType] = useState(undefined);

  return (
    <ExchangeTypeContext.Provider
      value={{
        exchangeType,
        setExchangeType,
      }}
    >
      {children}
    </ExchangeTypeContext.Provider>
  );
};

export { ExchangeTypeContext, ExchangeTypeContextProvider };
